<template>
  <div>
    <NewsMain></NewsMain>
  </div>
</template>

<script>
import NewsMain from "@/components/news/NewsMain.vue";

export default {
  name: "NewsMainView",
  components: {
    NewsMain
  }
};
</script>

<style></style>
